import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "../components/auth/AuthLayout";
import AppLayout from "../components/admin/AppLayout";
import store from "@/store/index";
import { getItem } from "@/helpers/persistanceStorage";

Vue.use(Router);

const EmptyParentComponent = {
  template: "<router-view></router-view>",
};

const demoRoutes = [];
const router = new Router({
  routes: [
    ...demoRoutes,
    {
      path: "*",
      redirect: { name: "orders" },
    },
    {
      path: "/auth",
      component: AuthLayout,
      children: [
        {
          name: "login",
          path: "login",
          component: () => import("../components/auth/login/Login.vue"),
        },
        {
          name: "signup",
          path: "signup",
          component: () => import("../components/auth/signup/Signup.vue"),
        },
        {
          name: "recover-password",
          path: "recover-password",
          component: () =>
            import("../components/auth/recover-password/RecoverPassword.vue"),
        },
        {
          path: "",
          redirect: { name: "login" },
        },
      ],
    },
    {
      path: "/404",
      component: EmptyParentComponent,
      children: [
        {
          name: "not-found-advanced",
          path: "not-found-advanced",
          component: () =>
            import("../components/pages/404-pages/VaPageNotFoundSearch.vue"),
        },
        {
          name: "not-found-simple",
          path: "not-found-simple",
          component: () =>
            import("../components/pages/404-pages/VaPageNotFoundSimple.vue"),
        },
        {
          name: "not-found-custom",
          path: "not-found-custom",
          component: () =>
            import("../components/pages/404-pages/VaPageNotFoundCustom.vue"),
        },
        {
          name: "not-found-large-text",
          path: "/pages/not-found-large-text",
          component: () =>
            import("../components/pages/404-pages/VaPageNotFoundLargeText.vue"),
        },
      ],
    },
    {
      name: "Admin",
      path: "/admin",
      component: AppLayout,
      children: [
        // {
        //   name: 'dashboard',
        //   path: 'dashboard',
        //   component: () => import('../components/dashboard/Dashboard.vue'),
        //   default: true
        // },
        {
          name: "products",
          path: "products",
          component: () => import("../pages/products/Products.vue"),
          default: true,
        },
        {
          name: "product-create",
          path: "products/create",
          component: () => import("../pages/products/ProductFormPage.vue"),
        },
        {
          name: "product-edit",
          path: "products/:slug/edit",
          component: () => import("../pages/products/ProductFormPage.vue"),
        },
        {
          name: "orders",
          path: "orders",
          component: () => import("../pages/orders/Orders.vue"),
          default: true,
        },
        {
          name: "order-create",
          path: "orders/create",
          component: () => import("../pages/orders/OrderCreate.vue"),
        },
        {
          name: "order-edit",
          path: "orders/:id(\\d+)/edit",
          component: () => import("../pages/orders/OrderCreate.vue"),
        },
        {
          name: "rejected-orders",
          path: "rejected-orders",
          component: () => import("../pages/rejected-orders/index.vue"),
          default: true,
        },
        {
          name: "categories-parent",
          path: "categories",
          component: EmptyParentComponent,
          children: [
            {
              name: "categories",
              path: "categories",
              component: () => import("../pages/categories/Categories.vue"),
            },
            {
              name: "reasons",
              path: "reasons",
              component: () => import("../pages/reasons/Reasons.vue"),
            },
          ],
        },
        {
          name: "locations",
          path: "locations",
          component: () => import("../pages/locations/Locations.vue"),
          default: true,
        },
        {
          name: "promocodes",
          path: "promocodes",
          component: () => import("../pages/promocodes/Promocodes.vue"),
          default: true,
        },
        {
          name: "additional-products",
          path: "additional-products",
          component: () =>
            import("../pages/additional-products/Additional-products.vue"),
          default: true,
        },
        {
          name: "florists",
          path: "florists",
          component: () => import("../pages/florists/Florists.vue"),
          default: true,
        },
        {
          name: "florist-reviews",
          path: "florist-reviews",
          component: () =>
            import("../pages/florist-reviews/FloristReviews.vue"),
          default: true,
        },
        {
          name: "florist-requests",
          path: "florist-requests",
          component: () =>
            import("../pages/florist-requests/FloristRequests.vue"),
          default: true,
        },
        {
          name: "reviews",
          path: "reviews",
          component: () => import("../pages/reviews/index.vue"),
          default: true,
        },
        {
          name: "callbacks",
          path: "callbacks",
          component: () => import("../pages/callbacks/Callbacks.vue"),
          default: true,
        },
        {
          name: "products-reviews",
          path: "products-reviews",
          component: () => import("../pages/products-reviews/index.vue"),
          default: true,
        },
        {
          name: "delivery",
          path: "delivery",
          component: () => import("../pages/delivery/index.vue"),
          default: true,
        },
        {
          name: "delivery-management",
          path: "delivery-management",
          component: EmptyParentComponent,
          redirect: { name: "delivery-types" },
          children: [
            {
              name: "delivery-types",
              path: "delivery-types",
              component: () =>
                import("../pages/delivery-management/DeliveryTypes.vue"),
            },
            {
              name: "delivery-slots",
              path: "delivery-slots",
              component: () =>
                import("../pages/delivery-management/DeliverySlots.vue"),
            },
            {
              name: "delivery-calendar",
              path: "delivery-calendar",
              component: () =>
                import("../pages/delivery-management/DeliveryCalendar.vue"),
            },
            {
              name: "delivery-slot-exceptions",
              path: "delivery-slot-exceptions",
              component: () =>
                import(
                  "../pages/delivery-management/DeliverySlotExceptions.vue"
                ),
            },
            {
              name: "delivery-promotions",
              path: "delivery-promotions",
              component: () =>
                import("../pages/delivery-management/DeliveryPromotions.vue"),
            },
          ],
        },
        {
          name: "content",
          path: "content",
          component: EmptyParentComponent,
          children: [
            {
              path: "",
              redirect: { name: "banners" },
            },
            {
              name: "banners",
              path: "promo-banners",
              component: () => import("../pages/banners/Banners.vue"),
            },
            {
              name: "main-page",
              path: "main-page",
              component: () =>
                import("../pages/customization/main-page/MainPage.vue"),
            },
            {
              name: "schema",
              path: "schema",
              component: () =>
                import("../pages/customization/schema/Schema.vue"),
            },
            {
              name: "catalog-menu",
              path: "catalog-menu",
              component: () =>
                import("../pages/customization/catalog-menu/CatalogMenu.vue"),
            },
            {
              name: "showcase",
              path: "showcase",
              component: () =>
                import("../pages/customization/showcase/Showcase.vue"),
            },
          ],
        },
        {
          name: "statistics",
          path: "statistics",
          component: EmptyParentComponent,
          children: [
            {
              name: "charts",
              path: "charts",
              component: () =>
                import("../components/statistics/charts/Charts.vue"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Charts",
              },
            },
            {
              name: "progress-bars",
              path: "progress-bars",
              component: () =>
                import(
                  "../components/statistics/progress-bars/ProgressBars.vue"
                ),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Progress-Bars",
              },
            },
          ],
        },
        {
          name: "forms",
          path: "forms",
          component: EmptyParentComponent,
          children: [
            {
              name: "form-elements",
              path: "form-elements",
              component: () =>
                import("../components/forms/form-elements/FormElements.vue"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/inputs",
              },
            },
            {
              name: "medium-editor",
              path: "medium-editor",
              component: () =>
                import("../components/forms/medium-editor/MediumEditor.vue"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor",
              },
            },
          ],
        },
        {
          name: "tables",
          path: "tables",
          component: EmptyParentComponent,
          children: [
            {
              name: "markup",
              path: "markup",
              component: () =>
                import("../components/markup-tables/MarkupTables.vue"),
              wikiLink:
                "https://github.com/epicmaxco/vuestic-admin/wiki/Tables", // TODO Update docs
            },
            {
              name: "data",
              path: "data",
              component: () =>
                import("../components/data-tables/DataTables.vue"),
              wikiLink:
                "https://github.com/epicmaxco/vuestic-admin/wiki/Tables", // TODO Add docs
            },
          ],
        },
        {
          name: "ui",
          path: "ui",
          component: EmptyParentComponent,
          children: [
            {
              name: "typography",
              path: "typography",
              component: () =>
                import("../components/ui/typography/Typography.vue"),
            },
            {
              name: "buttons",
              path: "buttons",
              component: () => import("../components/ui/buttons/Buttons"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Buttons",
              },
            },
            {
              name: "rating",
              path: "rating",
              component: () => import("../components/ui/rating/Rating"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Rating",
              },
            },
            {
              name: "color-pickers",
              path: "color-pickers",
              component: () =>
                import("../components/ui/color-pickers/ColorPickers"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Color-Pickers",
              },
            },
            {
              name: "timelines",
              path: "timelines",
              component: () => import("../components/ui/timelines/Timelines"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Timelines",
              },
            },
            {
              name: "notifications",
              path: "notifications",
              component: () =>
                import("../components/ui/notifications/Notifications"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Notifications",
              },
            },
            {
              path: "icons",
              component: () => import("../components/ui/icons/Icons"),
              children: [
                {
                  name: "icon-sets",
                  path: "", // Default route
                  component: () => import("../components/ui/icons/SetsList"),
                  meta: {
                    wikiLink:
                      "https://github.com/epicmaxco/vuestic-admin/wiki/Icons",
                  },
                },
                {
                  name: "icon-set",
                  path: ":name",
                  component: () => import("../components/ui/icons/IconSet"),
                  props: true,
                  meta: {
                    wikiLink:
                      "https://github.com/epicmaxco/vuestic-admin/wiki/Icons",
                  },
                },
              ],
            },
            {
              name: "spinners",
              path: "spinners",
              component: () => import("../components/ui/spinners/Spinners"),
            },
            {
              name: "grid",
              path: "grid",
              component: () => import("../components/ui/grid/Grid"),
            },
            {
              name: "modals",
              path: "modals",
              component: () => import("../components/ui/modals/Modals"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Modals",
              },
            },
            {
              name: "cards",
              path: "cards",
              component: () => import("../components/ui/cards/Cards"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Cards",
              },
            },
            {
              name: "file-upload",
              path: "file-upload",
              component: () =>
                import("../components/ui/file-upload/FileUpload"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/File-Upload",
              },
            },
            {
              name: "chips",
              path: "chips",
              component: () => import("../components/ui/chips/Chips"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Chips",
              },
            },
            {
              name: "tree-view",
              path: "tree-view",
              component: () => import("../components/ui/tree-view/TreeView"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Tree-view",
              },
            },
            {
              name: "collapses",
              path: "collapses",
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Collapse",
              },
              component: () => import("../components/ui/collapse/Collapses"),
            },
            {
              name: "colors",
              path: "colors",
              component: () => import("../components/ui/colors/Colors"),
            },
            {
              name: "spacing",
              path: "spacing",
              component: () => import("../components/ui/spacing/Spacing"),
            },
            {
              name: "sliders",
              path: "sliders",
              component: () => import("../components/ui/sliders/Sliders"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Sliders",
              },
            },
            {
              name: "popovers",
              path: "popovers",
              component: () => import("../components/ui/popovers/Popovers"),
            },
            {
              name: "chat",
              path: "chatPage",
              component: () => import("../components/ui/chat/ChatPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Chat",
              },
            },
            {
              name: "tabs",
              path: "tabs",
              component: () => import("../components/ui/tabs/Tabs"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Tabs",
              },
            },
            {
              name: "lists",
              path: "lists",
              component: () => import("../components/lists/Lists.vue"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Lists",
              },
            },
          ],
        },
        {
          name: "maps",
          path: "maps",
          component: EmptyParentComponent,
          children: [
            {
              name: "yandex-maps",
              path: "yandex-maps",
              component: () =>
                import("../components/maps/yandex-maps/YandexMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
            {
              name: "leaflet-maps",
              path: "leaflet-maps",
              component: () =>
                import("../components/maps/leaflet-maps/LeafletMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
            {
              name: "bubble-maps",
              path: "bubble-maps",
              component: () =>
                import("../components/maps/bubble-maps/BubbleMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
            {
              name: "line-maps",
              path: "line-maps",
              component: () =>
                import("../components/maps/line-maps/LineMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
          ],
        },
        {
          name: "pages",
          path: "pages",
          component: EmptyParentComponent,
          children: [
            {
              name: "404-pages",
              path: "404-pages",
              component: () =>
                import("../components/pages/404-pages/404PagesPage"),
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Проверяем наличие токена в localStorage
  const token = getItem("accessToken");

  // Если токена нет и мы не на странице логина, редиректим на логин
  if (!token && to.path !== "/auth/login") {
    next("/auth/login");
    return;
  }

  // Если токен есть, позволяем переход (восстановление пользователя произойдет в App.vue)
  // Если токен недействителен, axios interceptor обработает ошибку и сделает редирект
  if (token && to.path === "/auth/login") {
    // Если уже аутентифицирован, редиректим на главную
    const isLoggedIn = store.getters["auth/loggedIn"];
    if (isLoggedIn) {
      next({ name: "orders" });
      return;
    }
  }

  next();
});

export default router;
